import React from 'react'
import PropTypes from 'prop-types'
import { DialogTitle, IconButton, Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'

const SelectGroupDialogHeader = ({
  titleLocaleKey = 'groups.header.label',
  titleValues,
  onCloseDialog,
  className,
}) => {
  const titleContent = (
    <FormattedMessage id={titleLocaleKey} values={titleValues} />
  )

  return (
    <DialogTitle
      disableTypography={true}
      className={clsx(
        'text-18 font-medium flex-shrink-0',
        className || 'px-9 pt-9 pb-5',
      )}
    >
      <div className="flex items-center space-x-8 justify-between">
        <span className="flex items-center space-x-8 text-blue-950">
          {titleContent}
        </span>
        <div className="flex items-center">
          <IconButton
            aria-label="close"
            className="p-4"
            onClick={onCloseDialog}
          >
            <Icon className="text-24">close</Icon>
          </IconButton>
        </div>
      </div>
    </DialogTitle>
  )
}

SelectGroupDialogHeader.propTypes = {
  titleLocaleKey: PropTypes.string, // For FormattedMessage id (locale key), defaults to 'groups.header.label'
  titleValues: PropTypes.object, // Optional values object for FormattedMessage interpolation
  onCloseDialog: PropTypes.func.isRequired,
  className: PropTypes.string, // Optional className override
}

export default SelectGroupDialogHeader
